export const AnalyticsIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.438 10.938L16.875 7.5M9.063 8.438l2.5 2.5M3.125 12.5l4.063-4.063M17.813 7.5a.937.937 0 100-1.875.937.937 0 000 1.875zM12.5 12.813a.937.937 0 100-1.875.937.937 0 000 1.874zM8.125 8.438a.937.937 0 100-1.875.937.937 0 000 1.875zM2.188 14.375a.937.937 0 100-1.875.937.937 0 000 1.875z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
